import * as React from 'react';

require('../css/warning-banner.css');

interface Props {
  message: string;
  // Adding a property to add external css class. 
  divClassName?: string;
}

let WarningBanner = (props: Props) => {
  // Check if external css properties comes from parent
  let divUserClass = props.divClassName === null ? '' : props.divClassName;
  return <div className={`warning-banner ${divUserClass}`}>{props.message}</div>;
};

export default WarningBanner;



// WEBPACK FOOTER //
// ./src/Components/WarningBanner.tsx